<div class="body">
  <div class="container mt-4">
    <div class="title-box">
      <h3>Ver detalle <span class="sub-2">comisión</span></h3>
    </div>
    <div class="hr bg-green">Datos</div>
    <p>Aliado: {{this.nombreCliente | uppercase}}</p>
    <p>Valor total: {{this.valorTotal | currency:'USD' : 'symbol' : '1.0-0'}}</p>
    @if (this.estado === 'DEVUELTA REVISOR' || this.estado === 'ANULADA') {
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12">
        <div class="mb-3">
          <label for="" class="form-label">Motivo {{this.nombreCampo}}</label>
          <textarea class="form-control" style="height: 100px;" [disabled]="true">{{this.motivo}}</textarea>
        </div>
      </div>
    }
  </div>
  <div class="container mt-4">
    @if (listaSolicitudes.length>0) {
      <div class="row pr-3 pl-3">
        <div class="table-responsive">
          <table class="table table-striped table-borderless rounded">
            <thead class="table_head">
              <tr>
                <th scope="col" class="no-styles table-header">Número solicitud</th>
                <th scope="col" class="no-styles table-header">Nombre usuario</th>
                <th scope="col" class="no-styles table-header">Valor desembolsado</th>
                <th scope="col" class="no-styles table-header">Fecha de desembolso</th>
                <th scope="col" class="no-styles table-header">IVA comisión</th>
                <th scope="col" class="no-styles table-header">Valor comisión</th>
                <th scope="col" class="no-styles table-header">Valor total comisión</th>
              </tr>
            </thead>
            <tbody>
              @for (solicitud  of listaSolicitudes; track solicitud ; let i = $index) {
                <tr>
                  <td>{{solicitud.idSolicitudCredito}}</td>
                  <td>{{solicitud.nombreEmpresario | uppercase}}</td>
                  <td>{{solicitud.valorDesembolsado | currency:'USD' : 'symbol' : '1.0-0' }}</td>
                  <td>{{solicitud.fechaDesembolso | date: 'dd/MM/yyyy' : 'UTC' }}</td>
                  <td>{{solicitud.valorIva | currency:'USD' : 'symbol' : '1.0-0'}}</td>
                  <td>{{solicitud.valorComision | currency:'USD' : 'symbol' : '1.0-0'}}</td>
                  <td>{{solicitud.valorTotalComisionSolicitud | currency:'USD' : 'symbol' : '1.0-0'}}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-6"></div>
            <div class="col-6">
              <nav style="float: right;">
                <ul class="pagination">
                  <li class="page-item" [ngClass]="{disabled: paginaActual === 1}">
                    <button class="page-link pointer" (click)="selectPage(paginaActual - 1)" aria-label="Previous" [disabled]="paginaActual === 1">
                      <span aria-hidden="true">&laquo;</span>
                    </button>
                  </li>
                  @for (page of pages(); track page; let i = $index) {
                    <li class="page-item" [ngClass]="{active : (i + 1) === paginaActual}">
                      <a class="page-link pointer" (click)="selectPage(i + 1)">
                        {{ i + 1 }}
                      </a>
                    </li>
                  }
                  <li class="page-item" [ngClass]="{disabled: totalPaginas === paginaActual || totalPaginas === 1}">
                    <button class="page-link pointer" (click)="selectPage(paginaActual + 1)" [disabled]="totalPaginas === paginaActual || totalPaginas === 1" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="row justify-content-md-center">
      <div class="col-12 col-md-2 container-btn">
        <button class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="goBack()">Volver</button>
      </div>
    </div>
  </div>
  <div class="footer-body"></div>
</div>
<!-- Modal -->
<div class="modal fade" id="aceptar" tabindex="-1" aria-labelledby="aceptarModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body-monto m-3 text-center">
        <h4>Mensaje editado correctamente</h4>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-primary" (click)="aceptar()">Aceptar</button>
      </div>
    </div>
  </div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>

